import { HttpErrorResponse } from '@angular/common/http';
import { FieldTree, TreeValidationResult, ValidationError } from '@angular/forms/signals';
import { firstValueFrom, Observable } from 'rxjs';
import { ProblemDetail } from '../models/http-response-error.model';

export function createSubmitAction<TModel extends Record<string, any>>(
  observableFactory: (form: FieldTree<TModel>) => Observable<unknown>
): (form: FieldTree<TModel>) => Promise<TreeValidationResult> {
  return async (form: FieldTree<TModel>): Promise<TreeValidationResult> => {
    try {
      await firstValueFrom(observableFactory(form));
      return null;
    } catch (error) {
      const fieldErrors = toFieldErrors(error as HttpErrorResponse, form);

      if (fieldErrors.length === 0) {
        throw error;
      }

      return fieldErrors;
    }
  };
}

function toFieldErrors<TModel extends Record<string, any>>(
  httpErrorResponse: HttpErrorResponse,
  form: FieldTree<TModel>
): ValidationError.WithOptionalFieldTree[] {
  const problemDetail = httpErrorResponse.error as ProblemDetail | null;

  if (!problemDetail?.validationErrors?.length) {
    return [];
  }

  const fieldErrors: ValidationError.WithOptionalFieldTree[] = [];

  for (const validationError of problemDetail.validationErrors) {
    const fieldTree = (form as Record<string, unknown>)[validationError.field] as
      | FieldTree<unknown>
      | undefined;

    if (!fieldTree) {
      console.warn(`Campo ${validationError.field} não encontrado no formulário`);
      continue;
    }

    fieldErrors.push({
      kind: 'server',
      message: validationError.message,
      fieldTree
    });
  }

  return fieldErrors;
}
